import React from 'react';
import ReactTable from 'react-table';

import tableStyles from 'components/table/appTable.module.scss';
import { NextButton, PreviousButton } from 'components/table/buttons';
import { TableProps } from './Table.types';

export const Table = ({ loading, emails, pagination, changePagination, changePageSize, columns }: TableProps) => {
  return (
    <ReactTable
      loading={loading}
      columns={columns}
      className={tableStyles.appTable}
      noDataText={emails ? 'Sorry we could not find any results matching' : ''}
      data={emails || []}
      minRows={0}
      defaultSorted={[{ id: 'fullName', desc: false }]}
      NextComponent={NextButton}
      PreviousComponent={PreviousButton}
      defaultPageSize={pagination?.pageSize}
      pageSize={pagination?.pageSize}
      pages={Math.ceil(pagination?.count / pagination?.pageSize)}
      onPageChange={changePagination}
      page={pagination?.page - 1}
      onPageSizeChange={changePageSize}
      manual
    />
  );
};
